import * as React from 'react';

export const NotFound: React.SFC = () => (
  <div>
    <h1>404 - Diese Seite existiert nicht.</h1>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.tsx